import { useTheme } from '@mui/material';

export const useSxStyles = () => {
  const theme = useTheme();

  return {
    paper: {
      display: 'inline-flex',
      flexDirection: 'column',
      width: 'auto',
    },
    header: {
      padding: theme.spacing(1, 2),
    },
    tableContainer: {
      display: 'inline-flex',
      width: 'auto',
    },
  };
};
